<template>
  <section class="calendar">
    <v-container class="overflow-hidden container-large">
      <div
        class="
          d-flex
          justify-center
          align-center
          flex-column-reverse flex-md-row
        "
      >
        <div class="d-flex justify-center">
          <v-sheet
            max-width="500px"
            class="text-center align-center d-flex flex-column"
          >
            <TitleWidget class="mb-2">{{ item.title }}</TitleWidget>
            <p>{{ item.text }}</p>
            <ButtonWidget @click="buttonLink()" class="mt-3">{{
              button_text
            }}</ButtonWidget>
          </v-sheet>
        </div>
        <div class="px-15">
          <v-img :src="files + item.img" :alt="item.title" class="icon"></v-img>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import ButtonWidget from "../widgets/ButtonWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

//import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "calendar",
};

const _data = {
  button_text: "Conferir",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    buttonLink() {
      location.href =
        this.server + this.$rest("calendar").item.attachment.featured.path;
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  mounted() {
    console.log(this.item);
  },
  components: {
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.calendar {
  & .icon {
    max-width: 100%;
    width: 240px;
  }
}
@media (max-width: 767px) {
  .calendar {
    & .icon {
      max-width: 100%;
      width: 100px;
      margin-bottom: 30px;
    }
  }
}
</style>
